import { RemainingLimits } from '@components/ArtBoard/AIChat/components/AIChatSidebar/components/RemainingLimits'
import { SidebarHeader } from '@components/ArtBoard/AIChat/components/AIChatSidebar/components/SidebarHeader'
import { useEscapeLayer } from '@lib/escape'
import { ThemeColors } from '@octopus-do/octopus-storybook'
import { migrationArtBoardSelectors } from '@store/migrationSelectors/artBoardSelectors'
import { artBoardActions } from '@store/reducers/artboard'
import { useDispatch, useSelector } from 'react-redux'

import { clsJoin } from '@/utils'
import { ChatInput, ChatMessagesList } from './components'
import css from './styles.module.css'

export const AIChatSidebar = () => {
  const dispatch = useDispatch()
  const showAiChat = useSelector(migrationArtBoardSelectors.getIsShowAiChat)

  useEscapeLayer(showAiChat, () =>
    dispatch(artBoardActions.showAiChat({ showAiChat: false }))
  )

  if (!showAiChat) {
    return null
  }

  return (
    <div className={clsJoin(css.ai_chat_sidebar_container, ThemeColors.light)}>
      <SidebarHeader />

      <ChatMessagesList />

      <div className={css.ai_chat_sidebar_bottom}>
        <RemainingLimits />
        <ChatInput />
      </div>
    </div>
  )
}
